import React from 'react';
import OlousLogo from '../Assets/OlousLogo.png';
const FormFooterLeftSection = () => {
    return (
        <div className=' h-full flex items-center justify-start'>
            <img className='' src={OlousLogo} />
        </div>
    )
}

export default FormFooterLeftSection